import Helper from '@ember/component/helper';
import { isNone } from '@ember/utils';

export function chanceToBeatResult([ctbo], { significance = 0.95 } = {}) {
  if (isNaN(ctbo) || isNone(ctbo)) {
    return 'Need more data';
  } else if (ctbo > significance) {
    return 'Winner';
  } else if (ctbo < 1 - significance) {
    return 'Loser';
  } else {
    return 'Need more data';
  }
}

export default Helper.helper(chanceToBeatResult);
